<template>
  <div class="row">
    <div class="col-sm-12 col-md-8 mb-0">
      <title-bread-crumb :page="page" />
    </div>
    <div
      class="col-sm-12 col-md-4 d-flex justify-content-end align-items-center actions text-right"
    >
      <slot name="custom_actions" />
      <ActionButton
        v-if="hasReturn"
        i="fas fa-arrow-circle-left"
        variant="custom-btn-return m-2"
        @click="onReturn"
      >
        Regresar
      </ActionButton>
      <ActionButton
        v-if="hasSave"
        :disabled="saveDisabled"
        variant="success m-2"
        :i="`fas fa-save pr-1`"
        @click="save"
      >
        Guardar
      </ActionButton>
      <ActionButton
        v-if="hasAdd"
        variant="success m-2"
        :i="`fas fa-file-plus pr-1`"
        @click="add"
      >
        {{ addText }}
      </ActionButton>
      <ActionButton
        v-if="hasSubmit"
        :disabled="submitDisabled"
        variant="success m-2"
        :i="`fas fa-save pr-1`"
        @click="submit"
      >
        Someter
      </ActionButton>
      <ActionButton
        v-if="hasPrint"
        :disabled="printDisabled"
        variant="custom-btn-return m-2"
        :i="`fas fa-print pr-1`"
        @click="print"
      >
        Imprimir
      </ActionButton>
      <ActionButton
        v-if="hasContinue"
        variant="success m-2"
        i="fas fa-arrow-circle-right pr-1"
        @click="onContinue"
      >
        Continuar
      </ActionButton>

      <div v-for="action in actions" :key="action.name">
        <component
          :is="action.component || 'ActionButton'"
          v-if="action.visible || action.visible == null"
          class="mx-2"
          :i="action.icon"
          :text="action.text"
          :variant="action.variant"
          @click="eventHandler(action.click)"
        />
      </div>
    </div>
    <div class="col-12 p-0">
      <div class="dropdown-divider mt-0 pb-2 w-100 mb-4" />
    </div>
  </div>
</template>

<script>
import TitleBreadCrumb from '@/components/common/page/TitleBreadcrumb';
import { ActionButton } from '@/components/common';

export default {
  meta: {
    description: 'Muestra el encabezado con botones personalizados.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    TitleBreadCrumb,
    ActionButton,
  },

  props: {
    page: {
      type: Object,
      default: () => {},
      meta: {
        description: 'Estable el icono, título y ruta de referencia',
        example: '{ key1: value1, key2: value2 }',
      },
    },
    actions: {
      type: Array,
      default: () => [],
    },
    hasReturn: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Establece el botón regresar',
        example: 'true o false',
      },
    },
    hasSave: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Establece el botón guardar',
        example: 'true o false',
      },
    },
    hasSubmit: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Establece el botón enviar',
        example: 'true o false',
      },
    },
    hasPrint: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Establece el botón imprimir',
        example: 'true o false',
      },
    },
    hasAdd: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Establece el botón añadir',
        example: 'true o false',
      },
    },
    hasContinue: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Establece el botón continuar',
        example: 'true o false',
      },
    },
    submitDisabled: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Opción enviar deshabilitada',
        example: 'true o false',
      },
    },
    saveDisabled: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Opción enviar deshabilitada',
        example: 'true o false',
      },
    },
    printDisabled: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Opción imprimir deshabilitada',
        example: 'true o false',
      },
    },
    stickyButtons: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Establece iconos para los botones',
        example: 'true o false',
      },
    },
    addText: {
      type: String,
      default: () => 'Añadir',
      meta: {
        description: 'Establece el texto del encabezado',
        example: 'Texto Necesario',
      },
    },
  },
  methods: {
    add() {
      this.$emit('onAdd');
    },
    save() {
      this.$emit('onSave');
    },
    onReturn() {
      this.$emit('onReturn');
    },
    submit() {
      this.$emit('onSubmit');
    },
    print() {
      this.$emit('onPrint');
    },
    onContinue() {
      this.$emit('onContinue');
    },
    eventHandler(method) {
      if (method != null) {
        method();
      }
    },
  },
};
</script>

<style scoped>
.custom-btn-return {
  border: 1px solid #2db782;
  color: #2db782;
}

.custom-btn-return:hover {
  background-color: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}

@media screen and (max-width: 765px) {
  .actions {
    text-align: left !important;
    margin-left: 2%;
  }
}

@media screen and (max-width: 870px) {
  .actions {
    display: block !important;
  }

  .actions button {
    margin-bottom: 10px;
  }
}
</style>
